export const getWithOtherChargesColumn = (UseToPayAsCOD = 0) => [
  {
    id: 0, header: 'Serial Number', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }
  },
  {
    id: 1, header: 'Vehicle Number', exportHead: 'Vehicle No', field: 'BusNumber', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 2, header: 'Vehicle Mobile Number', exportHead: 'Vehicle MobileNo', field: 'ContactNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 3, header: 'Driver Name', exportHead: 'Driver Name', field: 'DriverConductorName', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 4, header: 'Seal Number', exportHead: 'Seal No', field: 'SealNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 5, header: 'Station', exportHead: 'Station', field: 'Station', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 6, header: 'Number of Parcel', exportHead: 'NOP', field: 'TotalUnits', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left', borderRight: '1px solid #ccc' }, isSortIcon: true,
  },
  {
    id: 7, header: 'Freight (Paid)', exportHead: 'Freight (Paid)', field: 'PaidFreight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 8, header: UseToPayAsCOD === 1 ? 'Freight (COD)' : 'Freight (ToPay)', exportHead: UseToPayAsCOD === 1 ? 'Freight (COD)' : 'Freight (ToPay)', field: 'TopayFreight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' }, isSortIcon: true,
  },
  {
    id: 9, header: UseToPayAsCOD === 1 ? 'Freight (CODDDDV)' : 'Freight (ToPayDDDV)', exportHead: UseToPayAsCOD === 1 ? 'Freight (CODDDDV)' : 'Freight (ToPayDDDV)', field: 'DDDVFreight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 10, header: 'Freight (OnAccount)', exportHead: 'Freight (OnAcc)', field: 'OnAccountFreight', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right', borderRight: '1px solid #ccc' }, isSortIcon: true,
  },
  {
    id: 11, header: 'Other Charges (Paid)', exportHead: 'Other Charges (Paid)', field: 'PaidOther', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 12, header: UseToPayAsCOD === 1 ? 'Other Charges (COD)' : 'Other Charges (ToPay)', exportHead: UseToPayAsCOD === 1 ? 'Other Charges (COD)' : 'Other Charges (ToPay)', field: 'TopayOther', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 13, header: UseToPayAsCOD === 1 ? 'Other Charges (CODDDDV)' : 'Other Charges (ToPayDDDV)', exportHead: UseToPayAsCOD === 1 ? 'Other Charges (CODDDDV)' : 'Other Charges (ToPayDDDV)', field: 'DDDVOther', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 14, header: 'Other Charges (OnAccount)', exportHead: 'Other Charges (OnAcc)', field: 'OnAccountOther', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right', borderRight: '1px solid #ccc' }, isSortIcon: true,
  },
  {
    id: 15, header: 'GST (Paid)', exportHead: 'GST (Paid)', field: 'PaidGST', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 16, header: 'GST (ToPay)', exportHead: 'GST (ToPay)', field: 'TopayGST', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 17, header: 'GST (ToPayDDDV)', exportHead: 'GST (ToPayDDDV)', field: 'DDDVGST', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 18, header: 'GST (OnAccount)', exportHead: 'GST (OnAcc)', field: 'OnAccountGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right', borderRight: '1px solid #ccc' }, isSortIcon: true,
  },
  {
    id: 19, header: 'Paid', exportHead: 'Paid', field: 'TotalPaid', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 20, header: 'ToPay', exportHead: 'ToPay', field: 'TotalToPay', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 21, header: 'ToPayDDDV', exportHead: 'ToPayDDDV', field: 'TotalToPayDDDV', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 22, header: 'OnAccount', exportHead: 'OnAccount', field: 'TotalOnAcc', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
  {
    id: 23, header: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' }, isSortIcon: true,
  },
]

export const FilterHeaderColumn = [
  {
    header: 'From Date',
    exportHead: 'From Date',
    field: 'fromDate',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'ToDate',
    exportHead: 'ToDate',
    field: 'toDate',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Dispatch By Branch',
    exportHead: 'Dispatch By Branch',
    field: 'selFromBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Destination City',
    exportHead: 'Destination City',
    field: 'selDestCity',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'selBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Vehicle Number',
    exportHead: 'Vehicle Number',
    field: 'selVehicle',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Payment Type',
    field: 'selPaymentTpe',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Report Type',
    field: 'reportType',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Report View',
    field: 'showSummaryReport',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Report Option',
    field: 'detailedFilter',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
]
export const MainHeaderColumn = [
  {
    header: 'Report For',
    exportHead: 'Report For',
    field: 'Report',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Company Name',
    exportHead: 'Company Name',
    field: 'companyName',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
]